import HttpHelpers from './helpers';

const PaymentMethodsApiEndpoints = {
  getCards: (): Promise<any> => HttpHelpers.authenticatedAxios
    .get('/api/v1/credit_cards')
    .then((response) => response.data),
  deleteCard: (cardId: string): Promise<any> => HttpHelpers.authenticatedAxios
    .delete(`/api/v1/credit_cards/${cardId}`),
  getTamaraOptions: (amount: number) => HttpHelpers.authenticatedAxios
    .get('/api/v1/tamara/options', { params: { amount } })
    .then((response) => response.data),
};

export default PaymentMethodsApiEndpoints;
